import React from 'react';

import {SvgProps} from '../../helpers/type';

const ArrowDown = ({className}: SvgProps): JSX.Element => {
    return (
        <svg
            width="46"
            height="46"
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <rect
                x="0.7125"
                y="0.912512"
                width="44.175"
                height="44.175"
                rx="9.42083"
                fill="#EDFCF2"
                fillOpacity="0.5"
            />
            <path
                d="M30.0367 20.4154H25.9014V14.2124L19.6983 14.2124V20.4154H15.563L22.7998 27.6523L30.0367 20.4154ZM15.563 29.72V31.7876H30.0367V29.72H15.563Z"
                fill="#5D847F"
            />
            <rect
                x="0.7125"
                y="0.912512"
                width="44.175"
                height="44.175"
                rx="9.42083"
                stroke="#E8EDEC"
                strokeWidth="1.425"
            />
        </svg>
    );
};

export default ArrowDown;
